import React from "react";

const SvgItalicIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 65 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="a">
          <path d="M0 0h65v80H0z" />
        </clipPath>
      </defs>
      <g clip-path="url(#a)">
        <path
          d="M64.644.624A1.681 1.681 0 0063.334 0H18.73a1.66 1.66 0 00-1.62 1.251L15.273 8.7a1.609 1.609 0 00.311 1.4 1.68 1.68 0 001.309.624h15.673L18.229 69.279H3.505a1.661 1.661 0 00-1.62 1.25L.047 77.98a1.608 1.608 0 00.311 1.4 1.681 1.681 0 001.309.62h44.6a1.66 1.66 0 001.62-1.251l1.841-7.449a1.608 1.608 0 00-.311-1.4 1.681 1.681 0 00-1.309-.625H32.669l14.335-58.554h14.491a1.659 1.659 0 001.62-1.25l1.838-7.451a1.61 1.61 0 00-.309-1.396z"
          data-name="Path 38526"
        />
      </g>
    </svg>
  );
};

export default SvgItalicIcon;
